export default {
  currentIndex: 0,
  engagements: {},
  completed: false,
  answerLoading: false,
  selectOnly: false,
};
